import React, { ReactNode } from 'react';
import { useTooltipContext } from './TooltipContext';

interface TooltipTriggerProps {
  children: ReactNode;
  disableHover?: boolean; // This disables whether the tooltip displays
  className?: string;
}

export const TooltipTrigger: React.FC<TooltipTriggerProps> = ({
  children,
  className,
  disableHover = false,
}) => {
  const { setOpen, refs } = useTooltipContext();

  const handleMouseEnter = () => {
    if (!disableHover) {
      setOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!disableHover) {
      setOpen(false);
    }
  };

  return (
    <div
      role="button"
      ref={refs.setReference}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={className}
    >
      {children}
    </div>
  );
};
